const removeClass = (node, className) => {
	// const item = document.querySelectorAll(`.${node}`);
	node.forEach((element) => {
		element.classList.remove(className);
	});
};

export {removeClass};
